// extracted by mini-css-extract-plugin
export default {"mainContainer":"bc_gb","contentViewport":"bc_gc"};